import { combineReducers } from 'redux';
import userReducer from './slices/userSlice';
import userAssetsReducer from './slices/userAssetsSlice';
import groupsReducer from './slices/groupsSlice';
import legaciesReducer from './slices/legacySlice';
import themeReducer from './slices/toggleSlice';
import loaderReducer from './slices/loaderSlice';

const rootReducer = combineReducers({
  user: userReducer,
  userAssets: userAssetsReducer,
  groups: groupsReducer,
  legacies: legaciesReducer,
  theme: themeReducer,
  loader: loaderReducer,

});

export default rootReducer;
